export function addPostType (posts) {
  posts.edges.forEach(post => {
    post.node.postType = posts.postTypeInfo.name
  })
  return posts
}